import React from 'react';
import * as ROUTES from '../../router/Routes';
import ContainerTemplate from '../../widgets/template/Container';
import CarnetView from './CarnetView';

const CarnetModule = () => {
  return (
    <ContainerTemplate active={ROUTES.carnet} routes={[ROUTES.controlEstudios]}>
      <CarnetView />
    </ContainerTemplate>
  );
};

export default CarnetModule;
